import { defineStore } from "pinia";
import { useCurationExperienceStore } from "@/features/experience-curation/stores/useCurationExperienceStore";
import { useCurrentExperienceTranslationsQuery } from "@/features/experience-curation/queries/useExperienceTranslationsQuery";
import { usePrimitiveModelWithChanges } from "@/features/core-shared/composables/usePrimitiveModelWithChanges";

export const useCurationSeoTitle = defineStore("curation-setting-seo-title-field", () => {
  const curationExperienceStore = useCurationExperienceStore();
  const translationsQuery = useCurrentExperienceTranslationsQuery();

  const initialValue = computed(() => translationsQuery.data.value?.seo_title ?? "");
  const { model, hasChanges, isFilled, reset } = usePrimitiveModelWithChanges(initialValue);

  const isRequired = true;
  const isReadonly = computed(() => curationExperienceStore.isReadonly);

  return {
    id: "seo_title",
    model,
    isRequired,
    isReadonly,
    isFilled,
    hasChanges,
    reset,
  };
});
